import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgHealthierChoiceFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m7.711 7.26 3.477-4.843a1 1 0 0 1 1.624 0L16.29 7.26 12 9.833 7.711 7.26Zm-1.17 1.63L4.7 11.454l7.3 4.379 7.299-4.38-1.84-2.563-4.945 2.967a1 1 0 0 1-1.03 0L6.542 8.89Zm13.93 4.194-7.956 4.774a1 1 0 0 1-1.03 0L3.53 13.084l-1.342 1.87a1 1 0 0 0 .293 1.438l9 5.463a1 1 0 0 0 1.038 0l9-5.463a1 1 0 0 0 .294-1.438l-1.343-1.87Z", fill: color }));
};
export default factorySvgIcon(SvgHealthierChoiceFilled);
//# sourceMappingURL=SvgHealthierChoiceFilled.js.map